import { AlertTriangle } from 'lucide-react';
import { STATUS_LABELS } from '../utils/constants';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

/**
 * Small indicator that renders next to a task's status pill when the
 * nightly `auto_pending_past_due_tasks` job (Feb 2026, iter52) has
 * auto-flipped the task from an active status → Pending because its
 * deadline slipped. Disappears the moment the user manually changes the
 * status (backend clears the stamps in update_task_status).
 */
export function AutoPendingBadge({ task, className = '' }) {
  if (!task?.auto_pending_flipped_at || task.status !== 'pending') return null;

  const prev = task.auto_pending_prev_status;
  const prevLabel = STATUS_LABELS[prev] || prev || 'active';
  let when = '';
  try {
    when = new Date(task.auto_pending_flipped_at).toLocaleString(undefined, {
      day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    when = task.auto_pending_flipped_at;
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex items-center justify-center h-5 w-5 rounded-full bg-amber-100 border border-amber-300 text-amber-700 cursor-help ${className}`}
            data-testid={`auto-pending-badge-${task.id}`}
          >
            <AlertTriangle className="h-3 w-3" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="font-semibold text-xs">Auto-flipped to Pending</p>
          <p className="text-[11px] mt-0.5">
            Was <b>{prevLabel}</b>, moved back on <b>{when}</b> because the
            deadline passed. Update the status once you&apos;ve triaged.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
